import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import LogoBanner from "../Menhomeone/LogoBanner";
import LazySection from "../Global/LazySection";
import ErrorBoundary from "../Global/ErrorBoundary";

// Lazy load all heavy components
const Usp = lazy(() => import("../Menhomeone/Usp"));
const Trusted = lazy(() => import("../Menhomeone/Trusted"));
const Service = lazy(() => import("../MenAboutus/Service"));
const ModelGallery = lazy(() => import("../Logo/ModelGallery"));
const VideoShowcase = lazy(() => import("../Menhomeone/VideoShowcase"));
const LogoWhyus = lazy(() => import("../Menhomeone/LogoWhyus"));
const LogoService = lazy(() => import("../Menhomeone/LogoService"));
const Howit = lazy(() => import("../Menhomeone/Howit"));
const ProdukLogo = lazy(() => import("../Logo/ProdukLogo"));
const PortfolioGallery = lazy(() => import("../Menhomeone/PortfolioGallery"));
const Call = lazy(() => import("../Menhomeone/Call"));
const Footer = lazy(() => import("../Global/Footer"));
const GoToTop = lazy(() => import("../Global/GoToTop"));

// Loading fallback component for better UX
const LoadingFallback = ({ message = "Memuat konten..." }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "60px 20px",
      minHeight: "400px",
    }}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px",
      }}
    >
      <div
        style={{
          width: "50px",
          height: "50px",
          border: "4px solid rgba(102, 126, 234, 0.2)",
          borderTop: "4px solid #667eea",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      ></div>
      <p style={{ color: "#667eea", fontSize: "16px", fontWeight: "600" }}>
        {message}
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  </div>
);

const Main = () => {
  return (
    <>
      <Helmet>
        <title>
          Jasa pembuatan | Logo badge emblem seragam sekolah ,perusahaan ,
          instansi,fashion , jaket , celana
        </title>
        <meta
          name="description"
          content="Logo Woven Mina - Jasa pembuatan | Logo badge emblem seragam sekolah ,perusahaan , instansi,fashion , jaket , celana"
        />
        <link rel="canonical" href="https://www.logowovenmina.com/" />
      </Helmet>
      <Preloader />
      <Header />
      <LogoBanner />
      <div className="page_wrapper">
        <LazySection>
          <Suspense fallback={null}>
            <Usp />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Trusted />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Service />
          </Suspense>
        </LazySection>

        <LazySection minHeight="600px">
          <ErrorBoundary
            title="Model 3D tidak dapat dimuat"
            message="Perangkat Anda mungkin tidak mendukung tampilan 3D. Silakan lanjutkan scrolling untuk melihat konten lainnya."
          >
            <Suspense
              fallback={<LoadingFallback message="Memuat Model 3D..." />}
            >
              <ModelGallery />
            </Suspense>
          </ErrorBoundary>
        </LazySection>

        <LazySection minHeight="600px">
          <ErrorBoundary
            title="Model 3D tidak dapat dimuat"
            message="Perangkat Anda mungkin tidak mendukung tampilan 3D. Silakan lanjutkan scrolling untuk melihat konten lainnya."
          >
            <Suspense
              fallback={<LoadingFallback message="Memuat Model 3D..." />}
            >
              <VideoShowcase />
            </Suspense>
          </ErrorBoundary>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <LogoWhyus />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <LogoService />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Howit />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <ProdukLogo />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <PortfolioGallery />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Call />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        </LazySection>

        <Suspense fallback={null}>
          <GoToTop />
        </Suspense>
      </div>
    </>
  );
};

export default Main;
